// Split a query into highlightable terms, mirroring the backend Lucene sanitize
// (strip operator chars, keep hyphen) so client highlighting matches server matching.
export function sanitizeTerms(query) {
  return (query || "")
    .replace(/[/\\()[\]{}"~*?:!+|&^]/g, " ")
    .split(/\s+/)
    .filter((t) => t.length > 1);
}

// Facet selection ({facetId: [values]}): toggling returns a NEW object so the
// search hook's dependency identity changes exactly when the selection does,
// and a facet with no values left is dropped from the request.
export function toggleFacetValue(selection, facetId, value) {
  const current = selection[facetId] || [];
  const next = current.includes(value) ? current.filter((v) => v !== value) : [...current, value];
  const { [facetId]: _removed, ...rest } = selection;
  return next.length ? { ...rest, [facetId]: next } : rest;
}
